import { DEVICE_ACTIONS, SOCKET_ACTIONS } from "./actions";
export interface IControllerReducer {
  isConnected: boolean;
  isStarted: boolean;
  startTime: string;
  stage: 0 | 1 | 2;
  queue: any[];
  counter: number;
  isInTimeout: boolean;
  maxReached: boolean;
  remaining: number;
  capacity: number;
}

const initialState: IControllerReducer = {
  isConnected: false,
  isStarted: false,
  startTime: "",
  stage: 0,
  queue: [],
  counter: 0,
  isInTimeout: false,
  maxReached: false,
  remaining: 0,
  capacity: 0,
};

export const socketReducer = (state: IControllerReducer = initialState, action): IControllerReducer => {
  switch (action.type) {
    case DEVICE_ACTIONS.CREATE_SOCKET: {
      return {
        ...state,
        isConnected: true,
      };
    }
    case DEVICE_ACTIONS.CLOSE_CONNECTION: {
      return {
        ...state,
        isConnected: false,
      };
    }
    case DEVICE_ACTIONS.SESSION_STARTED: {
      return {
        ...state,
        isStarted: true,
        queue: action.payload.queue,
        counter: action.payload.counter,
        remaining: action.payload.remaining || state.remaining,
        maxReached: action.payload.maxReached || state.maxReached,
      };
    }
    case DEVICE_ACTIONS.SET_DOOR_STAGE: {
      return {
        ...state,
        stage: action.payload,
      };
    }
    case DEVICE_ACTIONS.UPDATE_QUEUE: {
      const {
        queue,
        counter,
        maxReached,
        remaining,
        capacity,
      } = action.payload;
      return {
        ...state,
        queue,
        counter,
        maxReached: maxReached === undefined ? state.maxReached : maxReached,
        remaining: remaining || state.remaining,
        capacity: capacity || state.capacity,
      };
    }
    case DEVICE_ACTIONS.SET_IN_TIMEOUT: {
      return {
        ...state,
        isInTimeout: action.payload,
      };
    }
    case DEVICE_ACTIONS.SET_MAX_REACHED: {
      {
        return {
          ...state,
          maxReached: action.payload,
        };
      }
    }
    default:
      return state;
  }
};
